import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';

import * as userActions from '../actions/userActions';
import * as cartActions from '../actions/cartActions';


class Cart extends Component {
  componentWillMount() {
    // Async load FoxyCart loader script
    var script = document.createElement('script');
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Set callbacks for cart updates
    script.onload = () => {
      window.fc_script.onload = () => {
        var FC = window.FC || {};
        FC.client
          .on('ready.done', () => this.props.updateCart())
          .on('cart-submit.done', () => this.props.updateCart())
          .on('cart-item-quantity-update.done', () => this.props.updateCart())
          .on('cart-item-remove.done', () => this.props.updateCart())
          .on('cart-update.done', () => this.props.updateCart());
      }
    };

    var cartDomain = this.props.cartDomain;
    if(cartDomain.includes('.foxycart.com')) {
      cartDomain = cartDomain.replace('.foxycart.com', '');
    }

    script.src = `https://cdn.foxycart.com/${cartDomain}/loader.js`;  
  }

  render() {
    return (
      <a
        className={classnames({
          'cart': true,
          'hasItems': (this.props.itemCount ? this.props.itemCount > 0 : false)
        })} href = {`https://${this.props.cartDomain}/cart`}>
        <p className={'cart__summary'}>
          <i className={'material-icons'}>
            {'shopping_basket'}
          </i>
          <span className={'cart__count'}>{this.props.itemCount}</span>
        </p>
      </a>
    );
  }
}

function mapStateToProps(state) {
  return {
    cartDomain: state.cart.cartDomain,
    itemCount: state.cart.itemCount
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({...userActions, ...cartActions}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
